<template>

	<div class="modal fade show" tabindex="-1" role="dialog" style="display: block;">

		<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">

			<div class="modal-content">
				
				<div class="modal-header">
					<h5 class="modal-title">Modification les identifiants</h5>
				</div>

				<div class="modal-body">

					<div v-if="dialogErrTxt && dialogErr" class="alert alert-danger">
						{{ dialogErrTxt }}
					</div>

					<div v-if="dialogOkTxt" class="alert alert-success">
						{{ dialogOkTxt }}
					</div>

					<form class="container">

						<div class="row">
							<div class="col-6 pb-2">
								<m-form-text
									label="Identifiant application"
									placeholder="Identifiant"
									label-position="top"
									v-model="row_en.en_webapp_login"
									name="identifiant"
									autocomplete
								/>
							</div>
							<div class="col-6 pb-2">
								<m-form-text
									label="Mot de passe application"
									type="text"
									placeholder="Mot de passe"
									label-position="top"
									v-model="row_en.en_webapp_password"
									name="Mot de passe"
									autocomplete
								/>
							</div>
						</div>
						<div class="row">
							<div class="col-12 pb-2">
								<m-form-text
									label="Code administrateur"
									placeholder="Code Admin"
									label-position="top"
									v-model="row_en.en_admincode"
									name="code_admin"
									autocomplete
								/>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<m-form-text
									label="Mot de passe actuel"
									type="password"
									placeholder="Mot de passe"
									label-position="top"
									v-model="accountpswd"
									name="Mot de passe"
									autocomplete
								/>
							</div>
						</div>
					</form>
				</div>

				<div class="modal-footer">
					<button 
						type="button" 
						class="btn btn-secondary"
						@click="close"
					>
						Fermer
					</button>
					<button 
						type="button"
						class="btn btn-primary"
						@click="save()"
					>
						sauvegarder
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
  
<script>
export default {
	name: "editidentifiants",
	props: {
		row_en: {
		default: function () {
			return {};
		},
		type: Object,
		},
	},
	computed: {
		webappLogin() {
		return this.row_en.en_webapp_login;
		},
	},
	watch: {},
	data() {
		return {
			dialogErrTxt: "",
			dialogOkTxt: "",
			newmp: "",
			dialogErr: false,
			accountpswd: "",
		};
	},
	async mounted() {},
	methods: {
		close() {
			this.$emit("closeEditIdentifiants");
		},
		async save() {

			let response = await this.$axios.put(`${this.$config.server_url}/web/2.0/enduser/${this.row_en.en_id}`, {
				admincode: this.row_en.en_admincode,
				webapp_login: this.row_en.en_webapp_login,
				webapp_password: this.row_en.en_webapp_password,
				co_password: this.accountpswd,
			});

			if (response.data.data == "error") {
				this.dialogOkTxt = "";
				this.dialogErrTxt = "Une erreur est survenue, les identifiants n'ont pas pu être sauvegardées.";
				this.dialogErr = true;
				return;
			} else if (response.data.data == "wrong_password") {
				this.dialogOkTxt = "";
				this.dialogErrTxt = "Le mot de passe actuel est incorrect.";
				this.dialogErr = true;
				return;
			}

			this.dialogOkTxt = "Identifiants sauvegardés avec succès.";
			this.dialogErrTxt = "";
			this.$emit("closeEditIdentifiants");

		}
	}
};
</script>
  
<style lang="scss" scoped>

</style>
  